import React from 'react'
import useLocations from '../hooks/use-locations'
import { Table } from 'react-bootstrap'
import NewItem from './new-item'
import Item from './item'


const ReflectionPromptsPaginatedList = () => {
    const { locations, isLoading } = useLocations()

    const renderItem = ((item, key) => (
        <tr key={key}>
            <td>
                <Item id={item.id} name={item.name} />
            </td>
        </tr>
    ))

    return (
        <div>
            <Table striped bordered hover size="sm">
                <thead>
                    <tr>
                        <th>
                            <NewItem/>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {locations.map(renderItem)}
                </tbody>
            </Table>
        </div>
    )
}

export default ReflectionPromptsPaginatedList